import {
  SaveMetaMilestone_Input,
  useSaveClientReportMetaMilestoneMutation
} from 'generated/graphql';

import React from 'react';

export function useSaveClientReportMetaMilestone() {
  const [
    fnMutate,
    tuple
  ] = useSaveClientReportMetaMilestoneMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SaveMetaMilestone_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
